<template>
    <div>
<!--        <div class="brdr_box_w_checkbox">-->
<!--            <label class="switch_checkbox_item">-->
<!--                <input type="checkbox" :checked="appConfig['lead_to_atc']" @change="$emit('update', $event.target.checked, 'lead_to_atc')">-->
<!--                <div class="switch_checkbox"><span></span></div>-->
<!--            </label>-->
<!--            <h3>Trigger <b>AddToCart</b> event for new leads?-->
<!--                <info-icon>-->
<!--                    This will trigger <b>AddToCart</b> event whenever a new lead is recorded (<b>ie.</b> when the customer opts in at any step in your funnel, including two step order forms).-->
<!--                </info-icon>-->
<!--            </h3>-->
<!--        </div>-->

        <div class="__group_box layout-column">
            <div class="pixels_root">
                <h3>Pixel ID</h3>
                <div class="r_country_row mt15">
                    <input type="text" placeholder="Pixel ID" :value="appConfig['pixel']" class="control-input" @change="$emit('update', $event.target.value, 'pixel')">
                    <v-button border label="+" class="icon-pixel" @click="addItem" />
                </div>
            </div>
		        <div class="pixels_root">
			        <div class="r_country pixels_block" v-for="(item, pIndex) in appConfig.pixels" :key="pIndex">
				        <div class="r_country_row mt15">
					        <input type="text" placeholder="Pixel ID" :value="appConfig.pixels[pIndex].value" class="control-input" @change="editItem($event.target.value, pIndex)">
					        <v-button border class="icon-pixel" @click="deleteItem(pIndex)" label="-" />
				        </div>
			        </div>
		        </div>
        </div>

	    <div class="__group_box layout-column">
		    <div class="capi-wrapper">
			    <v-switch v-model="appConfig['is_capi']"
			              :value="appConfig['is_capi']">
				    Enable <b>Facebook Conversion API</b>?
				    <span class="tag">
					    recommended
				    </span>
			    </v-switch>
		    </div>
		    <div class="pixels_root" v-if="appConfig['is_capi']">
			    <input-field label="Access token" v-model="appConfig['access_token']" />
		    </div>
	    </div>

	    <div class="__group_box layout-column" :class="{'disabled':!funnel.funnel_type}">
		    <div class="layout-column events-wrapper">
			    <div class="layout-row ">
				    <div class="layout-column flex">
					    <h3>Events</h3>
					    <span>Select which events to be triggered.</span>
				    </div>
				    <div class="flex-center layout-column">
					    <v-button label="New event" slim border @click="newTrigger" :disabled="!funnel.funnel_type"
					              :icon="require('@/assets/img/add_plus_icon.svg')" />
				    </div>
			    </div>

			    <div class="layout-column events-list">
				    <div class="layout-column">
					    <div class="__no-triggers" v-if="!appConfig.triggers || !appConfig.triggers.length">
						    <span class="alert_box orange">No Facebook events were created, none will be triggered.</span>
					    </div>
					    <div v-else class="__entry-container" :ref="`fb_entry_${id}_${index}`"
					         v-for="(trigger,index) in appConfig.triggers" >
						    <fb-trigger-entry :trigger="trigger" :index="index" :selected-trigger="selectedTrigger"
						                      @delete="deleteTrigger(index)" @select="selectedTrigger=$event"/>
					    </div>
				    </div>
			    </div>

		    </div>
		    <expandable-area class="margin-t-15"  close-by-default title="Settings" tag="(optional)" name="app.fbpixel.settings">
			    <div class="margin-t-15 layout-row flex flex-center">
				    <v-switch class="margin-r-15" label="Enable test mode?" v-model="appConfig.test_mode" :value="appConfig.test_mode" />

				    <input-field v-if="appConfig.test_mode"
				                 class="" label="test_event_code"
				                 placeholder="eg. TEST46100" v-model="appConfig.test_event_code"  />
			    </div>
		    </expandable-area>

	    </div>

	    <div class=" alert_box orange">
		    <div class="icon">
			    <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')" />
		    </div>
		    <span>
		    Got any feedback or want to report any issues? <b class="let-us-know" @click="openIntercom">Let us know!</b>
		    </span>
	    </div>
    </div>
</template>

<script>
import InfoIcon from "@/components/base/info-icon";
import VButton from "@/components/base/v-button";
import VSwitch from "@/components/base/v-switch";
import InputField from "@/components/base/input-field";
import {mapGetters} from "vuex";
import stepTypes from "@/helpers/stepTypes";
import FbTriggerEntry from "@/views/funnels/apps/funnel-apps/fb/fb-trigger-entry";
import ExpandableArea from "@/components/base/expandable-area";
let instanceId = 0;
export default {
    name: 'Pixel',
    props: ['dataBufferObject','funnel'],
    components: {
	    ExpandableArea,
	    FbTriggerEntry,
	    InputField,
	    VSwitch,
	    VButton,
	    InfoIcon,
    },
    computed: {
			...mapGetters(['getStepDataStore']),
        pixelsCount() {
            return this.appConfig.pixels.length
        },
	    steps() {
				return [{id:0,name:"All steps"}, ...this.getStepDataStore] || [{id:0,name:"All steps"}];
	    }
    },
    data() {
        return {
					id: instanceId++,
					selectedTrigger: -1,
					stepTypes: stepTypes,
	        buttons: [
		        {id:'#submit-step',label:'#submit-step'},
		        {id:'#next-step',label:'#next-step'},
		        {id:'custom',label:'Custom'},
	        ],
					triggers: [
						{id:'visit',label:'Page visit'},
						{id:'click',label:'Button click'},
						{id:'optin',label:'Optin'},
						{id:'attempt',label:'Purchase attempt'},
						{id:'purchase',label:'Purchase'},
					],
        	events: [
		        {id:'purchase', name:'Purchase',
			        defaultTrigger:'purchase',
			        disabled:true, info:`<b>Purchase: </b> Purchase event is always triggered when a purchase takes place.`},
		        {id:'lead',name:'Lead',
			        defaultTrigger:'optin',
			        info:`<b>Lead: </b> Triggered when your customer opts in at any step by providing their email address.`},
		        {id:'atc',name:'Add To Cart',
			        defaultTrigger:'optin',
			        info:`<b>Add To Cart: </b> Triggered when a new lead is detected (similar to <b>Lead</b> event).`},
		        {id:'attempt',name:'Add Payment Info',
			        defaultTrigger:'attempt',
			        info:'<b>Add Payment Info: </b> Triggered when a purchase attempt is started by the user ' +
					        '<i>(ie. submitting credit card payment details, or PayPal checkout is started)</i>.'},
		        {id:'ic',name:'Initiate Checkout',
			        defaultTrigger:'attempt',
			        info:`<b>Initiate Checkout: </b> Triggered when a purchase attempt is started by the user`+
					        ` <i>(ie. submitting credit card payment details, or PayPal checkout is started)</i>, similar to <b>"Add Payment Info"</b> event.`},
	        ],
          appConfig: {},
        }
    },
    methods: {
			deleteTrigger(index) {
				if (index>=0) {
					this.appConfig.triggers.splice(index,1)
				}
			},
	    newTrigger() {
		    this.appConfig.triggers.push({trigger:"visit",event:"PageView", step_id:0,selector:"",custom:""})
		    let index = this.appConfig.triggers.length-1
		    this.selectedTrigger = index;

				this.$nextTick(()=>{
					let entry = this.$refs[`fb_entry_${this.id}_${index}`];
					if (entry && entry.length) {
						entry[0].scrollIntoView({ behavior: "smooth",block: 'center',
							inline: 'center' })
					}
				})
	    },
	    openIntercom() {
		    window.Intercom("showNewMessage", "Facebook pixel app feedback:\n");
	    },
        cAlert() {
	        this.$notify({
		        type:"warn",
		        group: "main",
		        title: "You have too many pixels, remove one first",
	        });
        },
        addItem() {
            if(this.pixelsCount<=3) {
                var saveStr = JSON.stringify(this.appConfig.pixels);
                var newPixels = JSON.parse(saveStr);
                newPixels.push({value: ''});
                this.$emit('update', newPixels, 'pixels');
            } else {
                this.cAlert()
            }
        },
        editItem(ev, index) {
            var saveStr = JSON.stringify(this.appConfig.pixels);
            var newPixels = JSON.parse(saveStr);
            newPixels[index].value = ev;
            this.$emit('update', newPixels, 'pixels');
        },
        deleteItem(index) {
            var saveStr = JSON.stringify(this.appConfig.pixels);
            var newPixels = JSON.parse(saveStr);
            newPixels.splice(index, 1);
            this.$emit('update', newPixels, 'pixels');
        }
    },
    created(){
			let triggers = [
		    {trigger:"visit",event:"PageView", step_id:0,selector:"",custom:""},
		    {trigger:"visit",event:"ViewContent", step_id:0,selector:"",custom:""},
		    {trigger:"purchase",event:"Purchase", step_id:0,selector:"",custom:""},
		    {trigger:"attempt",event:"InitiateCheckout", step_id:0,selector:"",custom:""},
		    {trigger:"attempt",event:"AddPaymentInfo", step_id:0,selector:"",custom:""},
		    {trigger:"optin",event:"Lead", step_id:0,selector:"",custom:""},
		    {trigger:"optin",event:"AddToCart", step_id:0,selector:"",custom:""},
	    ]
        if(this.dataBufferObject) {
          this.appConfig = this.dataBufferObject;
	        if (!this.appConfig.pixels) this.$set(this.appConfig, "pixels", []);
	        if (!this.appConfig.events) this.$set(this.appConfig, "events", {purchase:true,ic:true,attempt:true,lead:true,atc:true});
	        if (!this.appConfig.triggers) {
						let ar = [
							{trigger:"visit",event:"PageView", step_id:0,selector:"",custom:""},
							{trigger:"visit",event:"ViewContent", step_id:0,selector:"",custom:""},
							{trigger:"purchase",event:"Purchase", step_id:0,selector:"",custom:""},
						];
						let ev = this.appConfig.events;
		        if (ev.ic) ar.push({trigger:"attempt",event:"InitiateCheckout", step_id:0,selector:"",custom:""})
		        if (ev.attempt) ar.push({trigger:"attempt",event:"AddPaymentInfo", step_id:0,selector:"",custom:""})
		        if (ev.lead) ar.push({trigger:"optin",event:"Lead", step_id:0,selector:"",custom:""})
		        if (ev.atc) ar.push({trigger:"optin",event:"AddToCart", step_id:0,selector:"",custom:""})

						this.$set(this.appConfig, "triggers", ar);
	        }
        } else {
            this.appConfig = {
							"lead_to_atc":true,
	            "pixels":[],
	            "pixel":"",
	            "events":{"purchase":true},
	            triggers
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.__group_box {
	display: flex;
	border: 1px solid #E4E6F1;
	border-radius: 8px;
	padding: 15px;
	margin-bottom: 15px;
	&.disabled {
		pointer-events: none;
		opacity: 0.6;
		background: rgba(245, 245, 245, 0.5);
	}
}
.event-entry {
	border-bottom: 1px solid whitesmoke;
	//margin-bottom: 10px;
	margin-top: 10px;
	&:first-child {
		border-top: 1px solid whitesmoke;
		//padding-top: 10px;
	}
	padding-bottom: 10px;

}
.__no-triggers {
	margin: 30px auto;
}
.step-type-tag {
	font-size: 10px;
	display: flex;
	flex-direction: row;
	border: 1px solid whitesmoke;
	padding: 1px 6px;
	border-radius: 4px;
	width: fit-content;
}
.trigger-on {
	.label {
		margin: 3px 10px;
		white-space: nowrap;
		width: 60px;
		text-align: right;
	}
	.select-trigger {
		width: 160px;
	}
}
.let-us-know {
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
h3 {
	font-weight: 600;
	font-size: 16px;
}
.events-wrapper {
	margin-top: 5px;

	.events-list {
		margin: 10px 10px 10px 0;
	}
}
.icon-pixel {
	width: 41px;
	height: 41px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	border-radius: 6px;
	margin-left: 5px;
	border: 1px solid #C5C7D2;
	cursor: pointer;
	font-weight: 700;
	transition: all 0.3s ease;
	padding: 4px;
}
.tag {
	margin: 0;
}
</style>
